import ReactDOM from 'react-dom/client';

import App from './App';

// 由于集成了火山sdk，这里不能使用 React.StrictMode
ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
